<script setup lang="ts">
import { formatAmount, isFailedStatus, type TransactionTableRow } from '@peanuds/shared';

const { formatter, row } = defineProps<{
  formatter?: (row: TransactionTableRow) => string;
  row: TransactionTableRow;
}>();
</script>

<template>
  <span
    :class="{
      'cell-amount': true,
      'cell-amount--pos': row.type === 'INCOMING_TRANSFER',
      'cell-amount--failed': isFailedStatus(row),
    }"
  >
    {{ formatter ? formatter(row) : formatAmount(row) }}
  </span>
</template>

<style scoped lang="scss">
.cell-amount {
  white-space: nowrap;

  &--pos {
    color: #16a34a;
  }

  &--failed {
    text-decoration-line: line-through;
    color: var(--p-button-danger-background);
  }
}
</style>
